export const pathForTag = tag => {
  if (typeof tag === 'string') {
    return tag;
  }

  const { id, orgId, streamId, channelId, linkId } = tag;

  if (orgId && streamId && channelId && linkId) {
    return `${orgId}/${streamId}/${channelId}/${linkId}`;
  }

  if (orgId && streamId && channelId) {
    return `${orgId}/${streamId}/${channelId}`;
  }
  if (orgId && streamId) {
    return `${orgId}/${streamId}`;
  }
  if (orgId) {
    return orgId;
  }

  return id;
};
